import React, { createElement, useEffect, useState } from "react";
import PropTypes, { element } from "prop-types";
import "./styles.scss";
import Header from "./Header";
import Row from "./Row";
import Column from "./Column";
import { Auth } from "aws-amplify";
import {
  iconDownload,
  iconFile,
  iconDeleteDropdown,
  iconEdit,
} from "../common/icons";
import Chip from "../common/Chip";
import Checkbox from "../common/Checkbox";
import InputFile from "../common/InputFile";
import Modal from "../common/Modal";
import Button from "../common/Button";
import CardItem from "../common/CardItem";
import { callService } from "../../amplify/callService";
import Input from "../common/Input";
import { profileUsers, statusUsers } from "../../utils/options";
import Select from "../common/Select";
import { computeHeadingLevel } from "@testing-library/dom";
import { ro } from "date-fns/locale";
import { CONSTANTES } from "../../utils/Constantes";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../redux/actions/general";
import Alert from "../common/Alert";
import { getColorByStatusSunat } from "../../utils/utils";

const typesOfAdicFile = "image/*, application/pdf, text/*, audio/*, video/*";

const CustomTable = ({
  columns,
  data,
  hasInputFile,
  fields,
  preLabelClass,
  handleEdit = () => {},
}) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [tagBody, setTagBody] = useState("actions2");

  const handleShowModal = (row, tag) => {
    if (!showModal) setShowModal(true);
    setTagBody(tag);
    if (tag === "actions2") setSelectedRow(row);
    else if (tag === "edit") {
      let copy = { ...row };
      copy.profile = profileUsers.filter(
        (profUser) => profUser.text.toLowerCase() === row.profile.toLowerCase()
      )[0];
      copy.status = statusUsers.filter(
        (statusUser) =>
          statusUser.text.toLowerCase() === row.status.toLowerCase()
      )[0];
      setSelectedRow(copy);
    }
  };

  const handleCloseModal = (value) => {
    setSelectedRow(null);
    setShowModal(value);
  };

  const downloadFile = async (data, extensionFile) => {
    let obj = {
      payload: {
        typeFile: "documento",
        idData: data.id,
        extensionFile: extensionFile,
      },
    };
    let response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.getUrlDocs,
      obj
    );
    // if (response.ok) window.open(response.data, "_blank");
    if (response.ok) {
      fetch(response.data, { method: "GET" })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          let originalUrl = data.files
            .filter(
              (elem) => elem.type.toLowerCase() === extensionFile.toLowerCase()
            )[0]
            .url.split("/");
          let nameFile = originalUrl[originalUrl.length - 1];
          a.download = nameFile;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    }
  };

  const isExistFile = (fileObj) => {
    let existingFileIndex = files.findIndex(
      (f) => f.file.name === fileObj.file.name
    );
    return existingFileIndex;
  };

  const handleFiles = (newFiles) => {
    // console.log("newFiles local", newFiles);
    let copyFiles = [...selectedRow.filesAdic];
    for (const item of newFiles) {
      let indexFile = isExistFile(item);
      if (indexFile >= 0) {
        copyFiles[indexFile] = item;
      } else {
        copyFiles.push(item);
      }
    }
    let copySelectedRow = { ...selectedRow };
    copySelectedRow.filesAdic = copyFiles;
    setSelectedRow(copySelectedRow);
  };

  const clearFiles = () => {
    let copySelectedRow = { ...selectedRow };
    copySelectedRow.filesAdic = [];
    setSelectedRow(copySelectedRow);
  };

  const deleteFileFromRenderItem = (itemIndex) => {
    // let listFile = selectedRow.filesAdic.filter((file, index) => index !== itemIndex);
    let copySelectedRow = { ...selectedRow };
    copySelectedRow.filesAdic = copySelectedRow.filesAdic.filter(
      (file, index) => index !== itemIndex
    );
    setSelectedRow(copySelectedRow);
    // setFiles(listFile);
  };

  const bodyModalActions2 = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Lista de{" "}
            <span className="title-05 color-red">
              <strong>archivos adicionales</strong>
            </span>
          </h4>
          <h4 className="title-05 margin-bottom-32">
            del documento:{" "}
            <span className="title-05 color-red">
              <strong>
                {selectedRow ? selectedRow.docType : "..."}-
                {selectedRow ? selectedRow.docNumber : "..."}
              </strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          {
            <InputFile
              filesDefault={files || []}
              maxSizebyFile={5}
              maxSizeAllFile={15}
              acceptFiles={typesOfAdicFile}
              labelMessage="Máx. 5 MB por archivo y hasta 15 MB en total. Formatos: Cualquiera menos ejecutables"
              getFiles={(newFiles) => handleFiles(newFiles)}
              hideListItems={true}
              multiple
              title={{
                mobile: "Seleccione sus archivos",
                desktop: "Seleccione sus archivos",
              }}
            />
          }

          <div className="d-flex-between margin-bottom-16 margin-top-48">
            <h4 className="title-06">
              Documentos cargados (
              {selectedRow &&
                selectedRow.filesAdic &&
                selectedRow.filesAdic.length}{" "}
              archivo
              {selectedRow &&
                selectedRow.filesAdic &&
                (selectedRow.filesAdic.length > 1 ||
                  selectedRow.filesAdic.length === 0) &&
                "s"}{" "}
              cargado
              {selectedRow &&
                selectedRow.filesAdic &&
                (selectedRow.filesAdic.length > 1 ||
                  selectedRow.filesAdic.length === 0) &&
                "s"}{" "}
              )
            </h4>
            {selectedRow?.filesAdic && selectedRow.filesAdic.length >= 1 && (
              <div>
                <p className="title-07 pointer" onClick={() => clearFiles()}>
                  {iconDeleteDropdown} <span> Limpiar</span>
                </p>
              </div>
            )}
          </div>
          <div>
            {selectedRow && selectedRow.filesAdic
              ? selectedRow.filesAdic.map((f, index) => (
                  <CardItem
                    data={f}
                    deleteAction={() => deleteFileFromRenderItem(index)}
                    key={index}
                  />
                ))
              : []}
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (name, value) => {
    setSelectedRow({ ...selectedRow, [name]: value });
  };

  const bodyModalEdit = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>editar datos de usuario</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <Input
            label="Nombre completo"
            value={selectedRow.fullname}
            onChange={(newValue) => handleChange("fullname", newValue)}
          />
          <Input
            label="Email"
            value={selectedRow.email}
            onChange={(newValue) => handleChange("email", newValue)}
          />
          <Select
            label="Perfil"
            selected={selectedRow?.profile}
            onChange={(newValue) => handleChange("profile", newValue)}
            items={profileUsers}
          />
          <Select
            label="Estado"
            selected={selectedRow?.status}
            onChange={(newValue) => handleChange("status", newValue)}
            items={statusUsers}
          />
        </div>
      </div>
    );
  };

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);

  const handleClickModal = async () => {
    if (tagBody === "actions2") {
      if (selectedRow.filesAdic.length > 0) {
        const currentUser = await Auth.currentAuthenticatedUser();
        const rucUser = currentUser?.attributes["custom:ruc"];
        console.log("actions2 => ", selectedRow, rucUser);
        let file = selectedRow.filesAdic.map((elem) => {
          let nameFileUpload =
            elem && elem.file
              ? `${selectedRow.clientDoc}-${selectedRow.docNumber}-${elem.file.name}`
              : "";
          let obj = {
            filename: elem && elem.file ? nameFileUpload : "",
            typeFile: elem && elem.file ? elem.file.type : "",
            data:
              elem && elem.file
                ? elem.file.content.slice(elem.file.content.indexOf(",") + 1)
                : "",
          };
          return obj;
        });

        let objData;
        let nextFiles = [];
        let response;

        for (const itemFile of file) {
          if (itemFile.filename || itemFile.typeFile || itemFile.data) {
            nextFiles.push(itemFile);
          }
        }

        if (file.length > 0) {
          objData = {
            payload: {
              ID: selectedRow.id,
              dateTimeCreation: new Date(
                selectedRow.broadcast
              ).getMilliseconds(),
              files: nextFiles,
            },
          };
        }

        if (objData.payload.files.length > 0) {
          dispatch(showLoading());
          response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.uploadSust,
            objData
          );
        } else {
          setShowAlert({
            show: true,
            title: "Aviso",
            message: "No se encontraron documentos para cargar",
            type: "error",
          });
          resetMessage(5);
        }

        dispatch(hideLoading());
        console.log(
          "🚀 ~ file: index.jsx ~ line 313 ~ handleClickModal ~ response",
          response
        );
        if (response) setSelectedRow(null);
        handleCloseModal(false);
      } else {
        setShowAlert({
          show: true,
          title: "Aviso",
          message: "No se encontraron documentos para cargar",
          type: "error",
        });
        resetMessage(5);
      }
    } else if (tagBody === "edit") {
      handleEdit(selectedRow);
      handleCloseModal(false);
    }
  };

  return (
    <div className="customTable">
      {showAlert.show && (
        <Alert
          title={showAlert.title}
          message={showAlert.message}
          type={showAlert.type}
          hasBg={true}
          position="top-right"
          handleClose={() => resetAlert()}
        />
      )}
      <Header
        columns={columns}
        hasInputFile={hasInputFile}
        fields={fields}
        preLabelClass={preLabelClass}
      />
      {data.length ? (
        data.map((itemData, indexData) => (
          <Row key={indexData}>
            {fields.map((field, indexField) =>
              field.tag === "id" ? (
                <Column
                  classIn={`${preLabelClass}--${field.tag}`}
                  childrenDesktop={<Checkbox />}
                  showInResponsive={true}
                  key={`${indexData}.${indexField}`}
                  childrenResponsive={
                    <div className="d-flex">
                      <p className="title-08 w60">
                        <b> Seleccionar:</b>
                      </p>
                      <Checkbox />
                    </div>
                  }
                />
              ) : field.tag === "edit" ? (
                <Column
                  classIn={`${preLabelClass}--${field.tag}`}
                  childrenDesktop={
                    <div
                      className="pointer"
                      onClick={() => handleShowModal(itemData, "edit")}
                    >
                      {iconEdit}
                    </div>
                  }
                  showInResponsive={false}
                  key={`${indexData}.${indexField}`}
                />
              ) : field.tag === "sunatStatus" || field.tag === "status" ? (
                <Column
                  classIn={`${preLabelClass}--${field.tag}`}
                  childrenDesktop={
                    <Chip
                      label={itemData[field.tag]}
                      color={getColorByStatusSunat(itemData[field.tag])}
                    />
                  }
                  showInResponsive={true}
                  key={`${indexData}.${indexField}`}
                  childrenResponsive={
                    <Chip
                      label={itemData[field.tag]}
                      color={getColorByStatusSunat(itemData[field.tag])}
                    />
                  }
                />
              ) : field.tag === "actions" ? (
                <Column
                  key={`${indexData}.${indexField}`}
                  classIn={`${preLabelClass}--actions`}
                  childrenDesktop={
                    <div className="d-align-center gap30">
                      <div
                        className="d-flex pointer"
                        key={0}
                        onClick={() => downloadFile(itemData, "pdf")}
                      >
                        {iconDownload} <p>PDF</p>
                      </div>
                      <div
                        className="d-flex pointer"
                        key={1}
                        onClick={() => downloadFile(itemData, "xml")}
                      >
                        {iconDownload} <p>XML</p>
                      </div>
                    </div>
                  }
                  showInResponsive={true}
                  childrenResponsive={
                    <div className="d-align-center">
                      {itemData.files.map((f, f_index) => (
                        <div
                          className={`d-flex-center ${
                            f_index === 0 ? "margin-right-30" : ""
                          } pointer`}
                        >
                          <p className="title-08 w60">
                            <b> {f.type.toUpperCase()}</b>
                          </p>
                          {iconDownload}{" "}
                        </div>
                      ))}
                    </div>
                  }
                />
              ) : (
                <Column
                  longTxt={field.longTxt}
                  classIn={`${preLabelClass}--${field.tag}`}
                  childrenDesktop={itemData[field.tag]}
                  showInResponsive={true}
                  key={`${indexData}.${indexField}`}
                  childrenResponsive={
                    <div className={`${!field.longTxt ? "d-flex" : "w80"}`}>
                      <p className="title-08">
                        <b>{columns[field.tag]}:</b>
                      </p>
                      <span className="title-08">{itemData[field.tag]}</span>
                    </div>
                  }
                />
              )
            )}
            {hasInputFile && (
              <>
                <Column
                  key="0.0"
                  classIn={`${preLabelClass}--actions2`}
                  childrenDesktop={
                    <div
                      className="d-align-center pointer"
                      onClick={() => handleShowModal(itemData, "actions2")}
                    >
                      {iconFile}
                    </div>
                  }
                  showInResponsive={true}
                  childrenResponsive={
                    <div className="d-align-center pointer">
                      <div
                        className="margin-right-30 pointer d-flex-center"
                        onClick={() => handleShowModal(itemData, "actions2")}
                      >
                        <p className="title-08 w60">
                          <b> Archivos Adic:</b>
                        </p>
                        {iconFile}
                      </div>
                    </div>
                  }
                />
              </>
            )}
            {showModal && (
              <Modal
                className="rd--modal-info-files"
                onToggle={(value) => handleCloseModal(value)}
                visible={showModal}
                width={672}
                fullScreenMobile
                redHoverClosed
                onLabelClosed
                onLabelTextClosed="Cancelar"
                max12Padding
                footer={
                  <Button primary onClick={() => handleClickModal()}>
                    Guardar
                  </Button>
                }
              >
                {tagBody === "actions2" ? bodyModalActions2() : bodyModalEdit()}
              </Modal>
            )}
          </Row>
        ))
      ) : (
        <div className="d-flex-center padding-top-32">
          <h5 className="title-07">No se encontraron datos</h5>
        </div>
      )}
    </div>
  );
};

CustomTable.defaultProps = {
  columns: {},
  data: [],
  fields: [],
};

CustomTable.propTypes = {
  columns: PropTypes.object,
  data: PropTypes.array,
  hasInputFile: PropTypes.bool,
  fields: PropTypes.array,
  preLabelClass: PropTypes.string.isRequired,
};

export default CustomTable;
